import axios from "axios";

export const getManageOnboardingCandidatesGridService = (queryStr) => {
    return axios.get(`api/candidatesubmission/onboarding/manage?${`$count=true&`}${queryStr}`);
};

export const getManageOnboardingServiceForExcel = (queryStr) => {
    return axios.get(`api/candidatesubmission/onboarding/excel?${queryStr}`);
};
